var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDecline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0572 11.0572C11.5779 10.5365 12.4221 10.5365 12.9428 11.0572L16 14.1144L19.0572 11.0572C19.5779 10.5365 20.4221 10.5365 20.9428 11.0572C21.4635 11.5779 21.4635 12.4221 20.9428 12.9428L17.8856 16L20.9428 19.0572C21.4635 19.5779 21.4635 20.4221 20.9428 20.9428C20.4221 21.4635 19.5779 21.4635 19.0572 20.9428L16 17.8856L12.9428 20.9428C12.4221 21.4635 11.5779 21.4635 11.0572 20.9428C10.5365 20.4221 10.5365 19.5779 11.0572 19.0572L14.1144 16L11.0572 12.9428C10.5365 12.4221 10.5365 11.5779 11.0572 11.0572Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4C9.37258 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28ZM16 25.3333C21.1547 25.3333 25.3333 21.1547 25.3333 16C25.3333 10.8453 21.1547 6.66667 16 6.66667C10.8453 6.66667 6.66667 10.8453 6.66667 16C6.66667 21.1547 10.8453 25.3333 16 25.3333Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecline);
export default __webpack_public_path__ + "static/media/decline.601afc55b9ef9d397ff50b69fd595744.svg";
export { ForwardRef as ReactComponent };